module.exports = __webpack_public_path__ + "img/histogram.9f87304f.png";